/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancialHistorySource } from './FinancialHistorySource';
export type FinancialHistoryPeriod = {
  period_label: string;
  measurement_end_date: string;
  scenario: FinancialHistoryPeriod.scenario;
  revenue: number | null;
  revenue_growth: number | null;
  sources: Array<FinancialHistorySource>;
};
export namespace FinancialHistoryPeriod {
  export enum scenario {
    HISTORICAL = 'historical',
    PROJECTION = 'projection',
  }
}

